<template>
  <v-card class="min-height fluid-modal">
    <!-- <nav
      class="v-toolbar theme--dark bg-success-color"
      data-booted="true"
      style="margin-top: 0px; padding-right: 0px; padding-left: 0px; transform: translateY(0px);"
    >
      <div class="v-toolbar__content">
        <div class="v-toolbar__title text-white">Coming soon</div>
        <div class="spacer"></div>
          <button type="button" class="v-btn v-btn--icon theme--dark common-color" @click="$emit('close')">
            <div class="v-btn__content">
              <i
                aria-hidden="true"
                class="v-icon material-icons theme--dark"
              >close</i>
            </div>
          </button>
      </div> 
    
    </nav> -->
    <v-card-text>
      <div class="col-sm-12 p-allvw">
        <div class="feature pt-5 pb-5">
          <div>
            <featureSVG/>
          </div>
          <h5 class="text-center font-weight-bold m-0 pt-6">Doctor</h5>
          <p class="text-center mt-2">New Feature Announcement designs on Dribble... Exploring Dashboard UI alert announcement app card cta dashboard dashboard ui design</p>
          <div class="text-center mt-5">
            <v-btn elevation="2" class="btn default bg-white text-capitalize mr-4" @click="cancel()">Got it</v-btn>
            <v-btn class="btn info-text text-capitalize text-white border-radius">More info</v-btn>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<style lang="scss" scoped>
.feature{
  p{
    width:400px;
    margin:auto;
 }
 svg{
   width: 9.5rem;
    margin: auto;
    display: block;
 }
 .info-text{
   padding: 6px 20px!important;
   border:none!important;
   background-image: linear-gradient(to right, #8296e8 ,  #4158b7);
 }
  
}
</style>
<script>
import { pickSvg } from "@/views/SVG";
export default {
  components:{
    ...pickSvg("featureSVG")
  },
  methods:{
    cancel(){
      this.$emit("close");
    }
  }
}
</script>
